import { useEffect, useMemo, useRef, useState } from "react";
import { MantineReactTable, useMantineReactTable } from "mantine-react-table";
import { MantineProvider, Box, Global } from "@mantine/core";
// Chakra imports
import { useColorModeValue, useDisclosure } from "@chakra-ui/react";
// Custom components
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { getUsers } from "api/requests/getUsers";
import UserModal from "./components/userModal";
import { userData } from "./components/makeData";

function Reports() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [sorting, setSorting] = useState([{ id: "name", desc: false }]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const textColor = "white";
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const bgColor = "#4A5058";

  const { isOpen, onOpen, onClose } = useDisclosure();

  const axiosPrivate = useAxiosPrivate();

  const [users, setUsers] = useState([]);

  const loggedInUser = users?.find(
    (user) => user.username === localStorage.getItem("user")
  );

  const columns = [
    {
      accessorKey: "name",
      header: "User",
      size: 100,
    },
    {
      accessorKey: "username",
      header: "Username",
      size: 100,
    },
    {
      accessorKey: "email",
      header: "email",
      size: 130,
    },
    {
      accessorKey: "isActive",
      header: "isActive",
      size: 100,
      Cell: ({ cell }) => (
        <Box
          onClick={(e) => e.stopPropagation()}
          sx={{
            backgroundColor:
              cell.getValue() === "Active" ? "green.400" : "yellow.400",
            borderRadius: "4px",
            color: "#fff",
            maxWidth: "12ch",
            padding: "4px",
            textAlign: "center",
          }}
        >
          {cell.getValue() === "Active" ? "Active" : "Inactive"}
        </Box>
      ),
    },
  ];

  const table = useMantineReactTable({
    columns,
    data,
    enableBottomToolbar: true,
    enableColumnResizing: false,
    enableGlobalFilterModes: false,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    enablePagination: true,
    enablePinning: false,
    enableFacetedValues: false,
    enableDensityToggle: false,
    mantineTableProps: {
      sx: {
        backgroundColor: "dark",
      },
    },
    mantineTableContainerProps: {
      sx: { maxHeight: "615px" },
    },
    onSortingChange: setSorting,
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: (e) => {
        row.getToggleSelectedHandler()(e);
        handleRowClick(row.original);
      },
      sx: {
        cursor: "pointer",
      },
    }),
    initialState: {
      showGlobalFilter: true,
    },
    state: {
      isLoading,
      sorting,
      density: "xs",
    },
  });

  const handleRowClick = (clickedUser) => {
    // Search for the client in the list of clients by username
    const foundUser = users.find(
      (user) => user.username === clickedUser.username
    );

    if (foundUser) {
      setSelectedUser(foundUser);
      setIsModalOpen(true);
    } else {
      console.log("User not found:", clickedUser.username);
      // Optionally handle the case where no client is found
    }
  };

  const fetchUsers = async () => {
    const data = await getUsers(axiosPrivate);
    if (typeof window !== "undefined") {
      setData(userData(data));
      setIsLoading(false);
    }
    setUsers(data);
  };

  const handleUserUpdate = async () => {
    await fetchUsers();
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <>
      <Box pt={{ base: "150px", lg: "75px" }}>
        <MantineProvider
          theme={{
            colorScheme: useColorModeValue("light", "dark"),
            colors: {
              // override dark colors to change them for all components
              dark: [
                "#d5d7e0",
                "#acaebf",
                "#8c8fa3",
                "#666980",
                "#4A5058",
                "#343A40",
                "#343A40",
                "#4A5058",
                "#0c0d21",
                "#01010a",
              ],
              light: [],
            },
          }}
        >
          <Global
            styles={{
              ".mantine-TableHead": {
                zIndex: "1 !important",
              },
              ".chakra-MenuList": {
                zIndex: "9999 !important",
                position: "absolute !important",
              },
              ".chakra-Menu__menu-list": {
                zIndex: "9999 !important",
                position: "absolute !important",
              },
            }}
          />
          <MantineReactTable table={table} />
        </MantineProvider>
        <UserModal
          user={selectedUser}
          onClose={() => setIsModalOpen(false)}
          isOpen={isModalOpen}
          loggedInUser={loggedInUser}
          onUserUpdate={handleUserUpdate}
        />
      </Box>
    </>
  );
}

export default Reports;
